import { Card } from '@mui/material';
import React from 'react';

interface IBackstageProfileCard {
  heading: string;
  number: number;
  extraText?: string;
  icon: JSX.Element;
}

const spanStyles = {
  padding: '12px',
  borderRadius: '50%',
  color: '#cdae2b',
  backgroundColor: 'rgba(221, 185, 48,0.1)',
  width: '40px',
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const h2Styles = {
  fontSize: '28px',
  textAlign: 'left',
  color: 'white',
} as React.CSSProperties;

const h3Styles = {
  color: 'white',
  fontSize: '16px',
  textAlign: 'left',
  fontWeight: '100',
  opacity: 0.9,
  textTransform: 'uppercase',
  letterSpacing: '2px',
} as React.CSSProperties;

const extraStyles = {
  fontSize: '18px',
  color: 'white',
  opacity: 0.4,
} as React.CSSProperties;

const BackstageProfileCard = ({
  heading,
  number,
  extraText,
  icon,
}: IBackstageProfileCard) => {
  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '25px',
        backgroundColor: '#454354',
        padding: '20px',
        maxWidth: '150px',
        borderRadius: '20px',
      }}
    >
      <span style={spanStyles}>{icon}</span>
      <h3 style={h3Styles}>{heading}</h3>
      <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        <h2 style={h2Styles}>{number}</h2>
        <span style={extraStyles}>{extraText}</span>
      </div>
    </Card>
  );
};

export default BackstageProfileCard;
